import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (route, state): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService); 
  const router = inject(Router); 

  return authService.deviceInfo$.pipe(
    map(deviceInfo => {            
      if (deviceInfo.venue) {        
        return true
      } else {
        return router.createUrlTree(['/login']);
      }
    })
  )
}
